// extracted by mini-css-extract-plugin
export default {"newsList":"index-module_newsList_gq7v7","news":"index-module_news_YGHx3","time":"index-module_time_ZqjgS","title":"index-module_title_P2LiB"};